/* unplugin-vue-components disabled */import { render } from "./StudentScheduleDialog.vue?vue&type=template&id=d46df636&scoped=true"
import script from "./StudentScheduleDialog.vue?vue&type=script&lang=js"
export * from "./StudentScheduleDialog.vue?vue&type=script&lang=js"

import "./StudentScheduleDialog.vue?vue&type=style&index=0&id=d46df636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46df636"]])

export default __exports__